<form nz-form [formGroup]="validateForm" (ngSubmit)="submitForm(validateForm.value)" class="pb-4">
  <div nz-row>
    <div nz-col nzSpan="12">
      <nz-form-item>
        <nz-form-label [nzSpan]="24" nzRequired>Tên Đăng nhập</nz-form-label>
        <nz-form-control [nzSpan]="22" nzHasFeedback nzValidatingTip="Validating..." [nzErrorTip]="userErrorTpl">
          <input nz-input formControlName="userName" placeholder="async validate try to write JasonWood" [jAutofocus]/>
          <ng-template #userErrorTpl let-control>
            <ng-container *ngIf="control.hasError('required')"> Vui lòng nhập tên đăng nhập </ng-container>
            <ng-container *ngIf="control.hasError('duplicated')"> Tên đăng nhập không đúng </ng-container>
          </ng-template>
        </nz-form-control>
      </nz-form-item>
    </div>
    <div nz-col nzSpan="12">
      <nz-form-item>
        <nz-form-label [nzSpan]="24" nzRequired>E-mail</nz-form-label>
        <nz-form-control [nzSpan]="22" nzHasFeedback [nzErrorTip]="emailErrorTpl">
          <input nz-input formControlName="email" placeholder="email" type="email" />
          <ng-template #emailErrorTpl let-control>
            <ng-container *ngIf="control.hasError('email')"> Vui lòng nhập email </ng-container>
            <ng-container *ngIf="control.hasError('required')"> Email không đúng </ng-container>
          </ng-template>
        </nz-form-control>
      </nz-form-item>
    </div>
  </div>
  <div nz-row>
    <div nz-col nzSpan="12">
      <nz-form-item>
        <nz-form-label [nzSpan]="24" nzRequired>Mật khẩu</nz-form-label>
        <nz-form-control [nzSpan]="22" nzHasFeedback nzErrorTip="Please input your password!">
          <input nz-input type="password" formControlName="password" (ngModelChange)="validateConfirmPassword()" />
        </nz-form-control>
      </nz-form-item>
    </div>
    <div nz-col nzSpan="12">
      <nz-form-item>
        <nz-form-label [nzSpan]="24" nzRequired>Xác nhận mật khẩu</nz-form-label>
        <nz-form-control [nzSpan]="22" nzHasFeedback [nzErrorTip]="passwordErrorTpl">
          <input nz-input type="password" formControlName="confirm" [placeholder]="'Nhập lại mật khẩu'" />
          <ng-template #passwordErrorTpl let-control>
            <ng-container *ngIf="control.hasError('required')"> Vui lòng nhập lại mật khẩu </ng-container>
            <ng-container *ngIf="control.hasError('confirm')"> Nhập lại mật khẩu không đúng </ng-container>
          </ng-template>
        </nz-form-control>
      </nz-form-item>
    </div>
  </div>
  <div nz-row>
    <div nz-col nzSpan="12">
      <nz-form-item>
        <nz-form-label [nzSpan]="24">Lựa chọn</nz-form-label>
        <nz-form-control [nzSpan]="22">
          <nz-select formControlName="select"
            [nzMaxTagCount]="3"
            [nzMaxTagPlaceholder]="tagPlaceHolder"
            nzMode="multiple"
            nzPlaceHolder="Please select"
            [(ngModel)]="listOfSelectedValue"
          >
          <nz-option *ngFor="let item of listOfOption" [nzLabel]="item" [nzValue]="item"></nz-option>
          </nz-select>
        <ng-template #tagPlaceHolder let-selectedList> and {{ selectedList.length }} more selected </ng-template>
        </nz-form-control>
      </nz-form-item>
    </div>
    <div nz-col nzSpan="12">
      <nz-form-item>
        <nz-form-label [nzSpan]="24">Ngày tháng</nz-form-label>
        <nz-form-control [nzSpan]="22">
          <nz-range-picker formControlName="datetime" [(ngModel)]="date" (ngModelChange)="onChange($event)"></nz-range-picker>
        </nz-form-control>
      </nz-form-item>
    </div>
  </div>
  <div nz-row>
    <div nz-col nzSpan="24">
      <nz-form-item>
        <nz-form-label [nzSpan]="24" nzRequired>Bình luận</nz-form-label>
        <nz-form-control [nzSpan]="23" [nzErrorTip]="'Nhập bình luận...'">
          <textarea formControlName="comment" nz-input rows="2" [placeholder]="'Nhập bình luận'"></textarea>
        </nz-form-control>
      </nz-form-item>
    </div>
  </div>
  <div nz-row>
    <div nz-col nzSpan="24">
      <nz-form-item>
        <nz-form-label [nzSpan]="24" nzRequired>Bình luận</nz-form-label>
        <nz-form-control [nzSpan]="23" [nzErrorTip]="'Nhập bình luận...'">
          <textarea formControlName="comment" nz-input rows="2" [placeholder]="'Nhập bình luận'"></textarea>
        </nz-form-control>
      </nz-form-item>
    </div>
  </div>
  <div nz-row>
    <div nz-col nzSpan="24">
      <nz-form-item>
        <nz-form-label [nzSpan]="24" nzRequired>Bình luận</nz-form-label>
        <nz-form-control [nzSpan]="23" [nzErrorTip]="'Nhập bình luận...'">
          <textarea formControlName="comment" nz-input rows="2" [placeholder]="'Nhập bình luận'"></textarea>
        </nz-form-control>
      </nz-form-item>
    </div>
  </div>
  <div nz-row>
    <div nz-col nzSpan="24">
      <nz-form-item>
        <nz-form-label [nzSpan]="24" nzRequired>Bình luận</nz-form-label>
        <nz-form-control [nzSpan]="23" [nzErrorTip]="'Nhập bình luận...'">
          <textarea formControlName="comment" nz-input rows="2" [placeholder]="'Nhập bình luận'"></textarea>
        </nz-form-control>
      </nz-form-item>
    </div>
  </div>
  <div nz-row>
    <div nz-col nzSpan="24">
      <nz-form-item>
        <nz-form-label [nzSpan]="24" nzRequired>Bình luận</nz-form-label>
        <nz-form-control [nzSpan]="23" [nzErrorTip]="'Nhập bình luận...'">
          <textarea formControlName="comment" nz-input rows="2" [placeholder]="'Nhập bình luận'"></textarea>
        </nz-form-control>
      </nz-form-item>
    </div>
  </div>
  <div nz-row>
    <div nz-col nzSpan="24">
      <nz-form-item>
        <nz-form-label [nzSpan]="24" nzRequired>Bình luận</nz-form-label>
        <nz-form-control [nzSpan]="23" [nzErrorTip]="'Nhập bình luận...'">
          <textarea formControlName="comment" nz-input rows="2" [placeholder]="'Nhập bình luận'"></textarea>
        </nz-form-control>
      </nz-form-item>
    </div>
  </div>
  <div nz-row>
    <div nz-col nzSpan="24">
      <nz-form-item>
        <nz-form-label [nzSpan]="24" nzRequired>Bình luận</nz-form-label>
        <nz-form-control [nzSpan]="23" [nzErrorTip]="'Nhập bình luận...'">
          <textarea formControlName="comment" nz-input rows="2" [placeholder]="'Nhập bình luận'"></textarea>
        </nz-form-control>
      </nz-form-item>
    </div>
  </div>
</form>
<div class="drawer-footer">
  <button class="mr-2" nz-button (click)="resetForm($event)">Cài lại</button>
  <button class="mr-2" nz-button (click)="close($event)">Đóng</button>
  <button class="mr-2" nz-button nzType="primary" [disabled]="!validateForm.valid">Thêm</button>
</div>

